import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { oyanAuthGuard } from './features/auth/guards/auth.guard';
import { OyanUiRoutingConstants } from './oyan-ui.router.constants';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./containers/app-shell/app-shell.module').then((m) => m.OyanUiAppShellModule),
    canActivate: [oyanAuthGuard]
  },
  {
    path: OyanUiRoutingConstants.LOGIN,
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.OYAN_UI_AUTH_ROUTES)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OyanUiRouterModule {}
